import type { IconSvgObject } from './types';

const MaterialAndTextureIcon: IconSvgObject = [
  ["path", { d: "M9.5 14.5002L17.7387 10.5977M11.3171 10.8152L6 13.2692", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 7.00026L12 3L3 7.00026L11.9995 11L21 7.00026Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.4338 9.52637L21 12.0004L11.9995 16.0001L3 12.0004L8.5662 9.52637", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15.5 14.5557L21 17.0003L11.9995 21L3 17.0003L8.5 14.5557", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MaterialAndTextureIcon;
